'use strict';

module.exports = function when(value, fn) {
  if (value) {
    fn(this);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/when.js
// module id = 306
// module chunks = 0